import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import RegisterModal from '../../components/auth/RegisterModal';
import LoginModal from '../../components/auth/LoginModal';
import './AuthPage.css'; // Using the shared CSS file

const RegisterPage = () => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  // If user is already authenticated, redirect to appropriate dashboard
  useEffect(() => {
    if (isAuthenticated) {
      if (user?.user_type === 'content_creator' || user?.user_type === 'super_admin') {
        navigate('/dashboard/content-creator');
      } else if (user?.user_type === 'general_user') {
        navigate('/dashboard/general-user');
      }
    }
  }, [isAuthenticated, user, navigate]);

  // Handle switching to login modal
  const onBackToLogin = () => {
    setShowLoginModal(true);
  };

  // Handle closing login modal
  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
  };

  // Handle registration success
  const handleRegistrationSuccess = () => {
    // Show success message and then redirect to login after delay
    setTimeout(() => {
      setShowLoginModal(true);
    }, 10000);
  };

  // Handle login success and navigate to dashboard
  const handleLoginSuccess = (userData) => {
    sessionStorage.setItem('userData', JSON.stringify(userData));
    if (userData?.user_type === 'content_creator' || userData?.user_type === 'super_admin') {
      navigate('/dashboard/content-creator');
    } else {
      navigate('/dashboard/general-user');
    }
  };

  return (
    <div className="auth-page-container">
      {/* Use the existing RegisterModal with isOpen always true for the page version */}
      <RegisterModal 
        isOpen={true} 
        onClose={() => navigate('/')} 
        onBackToLogin={onBackToLogin}
        onRegistrationSuccess={handleRegistrationSuccess}
        isStandalonePage={true} // Prop to indicate this is used as a page, not a modal
      />
      
      {/* Login Modal that appears when user clicks "Login" from the registration form */}
      <LoginModal 
        isOpen={showLoginModal} 
        onClose={handleCloseLoginModal} 
        onSwitchToRegister={() => setShowLoginModal(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  );
};

export default RegisterPage;